import { DomainService } from 'app/core/services/domain.service';
import { Injectable } from '@angular/core';
import { ConfigService } from 'app/core/services/config.service';
import { RequestService } from 'app/core/services/request.service';
import { Observable } from 'rxjs/Observable';
import { FormControl } from '@angular/forms';

@Injectable()
export class ItpxValidators {

    constructor(
        private requestService: RequestService,
        private configService: ConfigService,
        private domainService: DomainService
    ) { }

    emailAvailable(control: FormControl) {

        return Observable.timer(100)
            .take(1)
            .flatMap(_ => this.getUsernameAvailability(control.value))
            .map(body => body.data.alreadyRegistered ? { msg: 'brandedPortal.redeemVoucher.messages.emailAlreadyExists' } : null);
    }

    private getUsernameAvailability(username: string): Observable<any> {
        let url = this.configService.get('server').brandedApiUrl
            + this.configService.get('endpoints').public.registration.validateUsername.api
            + '/' + encodeURIComponent(username);

        return this.requestService.get(url, {}, 'json', true)
            .map(({data}) => ({data, username}));
    }

    static emailValidator(control: FormControl) {
        if (control.value && typeof control.value === 'string' && ItpxValidators.matchesEmailPattern(control.value)) {
            return null;
        }

        return { msg: 'Invalid email address.' };
    }

    static booleanValidator(control: FormControl) {
      if (control.value && typeof control.value === 'boolean' && control.value === true) {
        return null;
      }

      return { msg: 'brandedPortal.GDPR.requiredConsent' };
    }

    static matchesEmailPattern(val: string): boolean {
        return /^(([^<>()\[\]\\.,;:\s@/"]+(\.[^<>()\[\]\\.,;:\s@"/]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(val);
    }

    static nonAsciiCharacter(control: FormControl) {
      if (/[^\x00-\x7F]/g.test(control.value)) {
        return { custom: {message: 'brandedPortal.validation.noSpecialCharacterAllowed' }};
      }

      if (/[0-9]+/g.test(control.value)) {
        return { custom: {message: 'brandedPortal.validation.noNumbersAllowed' }};
      }

      if (/((?![a-zA-Z ]).)/g.test(control.value)) {
        return { custom: { message: 'brandedPortal.validation.noSymbolsAllowed' }};
      }

      return null;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/validators/itpx-validators.ts